import Vue from "vue";
import axios from "axios";
import qs from "qs";
import router from "../router";

// 应用ID，学生小程序：1，教师APP（大屏端）：2，分销端H5：3
const appid = 6;

(axios.defaults.baseURL =
  process.env.NODE_ENV === "production"
    ? "https://open.xiaobixiezi.com/index.php"
    : "/"),
  axios.interceptors.request.use((config) => {
    config.headers["appid"] = appid;
    let token = sessionStorage.getItem("xiaobi_access_token");

    if (token && !config.headers["access-token"]) {
      config.headers["access-token"] = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
      config.data = qs.stringify(config.data);
    }

    return config;
  });

axios.interceptors.response.use(
  (response) => {
    if (response.status !== 200 && response.status !== 201) {
      console.log("请求异常，Error::" + response.status);
      Vue.prototype.$layer.msg("请求失败，请检查网络设置！");
      return null;
    } else {
      if (response.data.code == "401") {
        router.replace("/login");
      }
      if (response.data.code != "200") {
        if (response.config.url != "/api/v2/handwriting/Pub/codeLogin") {
          Vue.prototype.$layer.msg(response.data.msg);
        }
      }
      return response.data || {};
    }
  },
  (response) => {
    console.log("请求异常，Error::" + response.message);
    Vue.prototype.$layer.msg("请求失败，请检查网络设置！");
  }
);

Vue.prototype.$http = axios;
